import {
  FreeCheckedBaggageAllowanceItem,
} from '@dapi/sdk';
import {
  arnEwrFlightItem,
  cphOslFlightItem,
  oslCphFlightItem,
} from './flights';
import {
  traveler,
  traveler2,
  traveler3,
} from './traveler';

export const cplOshReturnBaggageAllowanceItems: FreeCheckedBaggageAllowanceItem[] = [
  {
    details: {
      type: 'weight',
      weightUnit: 'kilogram',
      quantity: 20
    },
    flightIds: [cphOslFlightItem.id],
    travelerIds: [traveler.id]
  },
  {
    details: {
      type: 'weight',
      weightUnit: 'kilogram',
      quantity: 20
    },
    flightIds: [oslCphFlightItem.id],
    travelerIds: [traveler.id]
  }
];

export const arnEwrBaggageAllowanceItems: FreeCheckedBaggageAllowanceItem[] = [
  {
    details: {
      type: 'piece',
      quantity: 2
    },
    flightIds: [arnEwrFlightItem.id],
    travelerIds: [traveler.id, traveler2.id]
  },
  {
    details: {
      type: 'piece',
      quantity: 2
    },
    flightIds: [arnEwrFlightItem.id],
    travelerIds: [traveler3.id]
  }
];

export const arnEwrBaggageAllowanceItemsForTwoPax: FreeCheckedBaggageAllowanceItem[] = [
  {
    details: {
      type: 'piece',
      quantity: 2
    },
    flightIds: [arnEwrFlightItem.id],
    travelerIds: [traveler.id]
  },
  {
    details: {
      type: 'piece',
      quantity: 2
    },
    flightIds: [arnEwrFlightItem.id],
    travelerIds: [traveler2.id]
  }
];
